import { v2 } from '@saucelabs/sl-module-builds';

import * as selectors from './selectors';
import { NAMESPACE } from './types';

const operations = v2.buildsList.operations.createVDCOperations(NAMESPACE, selectors);
export const openSourceOperations = v2.buildsList.operations.createVDCOperations(
  NAMESPACE, selectors, true,
);

export default operations;
